import { render } from "./FileCollection.vue?vue&type=template&id=1868aee3&scoped=true"
import script from "./FileCollection.vue?vue&type=script&lang=js"
export * from "./FileCollection.vue?vue&type=script&lang=js"

import "./FileCollection.vue?vue&type=style&index=0&id=1868aee3&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1868aee3"]])

export default __exports__